import { Component,  Input } from '@angular/core';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'gallery-card',
    template: `
<div class="entity-card smooth" [ngClass]="{ hideName: hideName }" *ngIf="!!entity">
  <div class="entity-logo" *ngIf="entity.logoUrl">
    <img [src]="entity.fullLogoUrl || entity.logoUrl">
  </div>
  <div class="name-holder" *ngIf="!hideName"><div class="entity-name">{{ entity?.name }}</div></div>
</div>
`,
    styleUrls: ['gallery-card.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class GalleryCardComponent {
  @Input() entity: Sponsor | Exhibitor
  @Input() hideName = false
  
}



